import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {UserModel} from '@app/models/user';
import User = UserModel.User;
import {UserRepository, UserSearchResult} from '@app/@core/repositories/user.repository';
import {matchSorter} from 'match-sorter';
import {UserStoreService} from '@app/@core/services/user-store.service';

@Component({
    template: `
      <p-autoComplete
        [style]="{'width':'400px'}" [inputStyle]="{'width':'400px'}"
        [(ngModel)]="selectedUser"
        [multiple]="false"
        [dropdown]="true"
        [forceSelection]="true"
        field="email"
        minLength="3"
        [suggestions]="filteredUser"
        (completeMethod)="filterUser($event)"
        (ngModelChange)="changed($event)"
        placeholder="Name, email, mobile">
        <ng-template let-value pTemplate="item">
          <div> {{value.email}} : {{value.fname || '-'}} {{value.lname}} ({{value.mobile || '?'}})</div>
        </ng-template>
      </p-autoComplete>
    `,
    selector: 'app-user-select',
    styles: []
})
export class UserSelectComponent<T> implements OnChanges {
    @Input() user: UserSearchResult;
    @Output() selected = new EventEmitter<UserSearchResult>();

    selectedUser: UserSearchResult;
    filteredUser: UserSearchResult[] = [];

    constructor(private userRepository: UserRepository,
                private userStoreService: UserStoreService
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
    }

    search() {
        console.log(this.selectedUser);
    }

    filterUser($event) {
        if ($event.query) {
            this.userRepository.search($event.query).subscribe({
                next: users => {
                    this.filteredUser = matchSorter(users, $event.query, {keys: ['fname', 'lname', 'email', 'mobile']});
                }
            });
        }else {
            this.filteredUser = [...this.userStoreService.getRecentUsers()];
        }
    }

    changed(user: User) {
        this.selected.emit(user);
    }
}
